if (!customElements.get('scroll-to-buttons')) {
  customElements.define(
    'scroll-to-buttons',
    class ScrollToButtons extends HTMLElement {
      constructor() {
        super();

        this.isAnimating = false;
        this.isScrolling = false;
        this.scrollTimeout = null;
        this.setupEvents();
        this.setupIntersectionObserver();
        this.setupScrollTracking();
        this.trackScrollButtons();

        if(!this.dataset.designMode === 'true') return;
        this.designMode();
      }

      scrollToTarget(button) {
        const targetId = button.dataset.scrollTarget;
        const targetElement = document.getElementById(targetId);
        
        if (!targetElement) return;
        const calculatePosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const targetPosition = button.hasAttribute('data-scroll-button-target-product') ? 0 : calculatePosition;
        
        window.scroll({
          top: targetPosition,
          behavior: 'smooth'
        });
      }

      setupEvents() {
        if (this.scrollButtons.length < 1) return;

        this.scrollButtons.forEach(button => {
          button.addEventListener('click', (event) => {
            this.scrollToTarget(button);
          });
        });
      }

      toggleStickyReveal(open) {
        if (this.stickyReveal === open) return;
        this.dataset.stickyReveal = open;
      }

      setupIntersectionObserver() {
        if(!this.stickyRevealTarget) return;

        const options = {
          root: null,
          rootMargin: '0px 0px -150px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            entry.isIntersecting ? this.toggleStickyReveal(false) : this.toggleStickyReveal(true);
          });
        }, options);

        if (this.stickyRevealTarget) {
          observer.observe(this.stickyRevealTarget);
        }
      }

      setupScrollTracking() {
        window.addEventListener('scroll', this.startScrollTracking.bind(this));
        window.addEventListener('scroll', this.handleScroll.bind(this)); // Track scrolling state
      }

      startScrollTracking() {
        if (!this.isAnimating) {
          this.isAnimating = true;
          this.trackScrollButtons();
        }
      }

      handleScroll() {
        this.isScrolling = true;
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          this.isScrolling = false;
        }, 100);
      }

      toggleActiveButton(activeTarget) {
        this.trackingButtons.forEach(button => {
          if (activeTarget && button == activeTarget) {
            if (!button.hasAttribute('aria-current'))
              button.setAttribute('aria-current', 'true');
          } else {
            if (button.hasAttribute('aria-current'))
              button.removeAttribute('aria-current');
          }
        });
      }

      trackScrollButtons() {
        this.trackingButtons.forEach((button, index) => {
          const targetId = button.dataset.scrollTarget;
          const targetElement = document.getElementById(targetId);
          const rect = targetElement.getBoundingClientRect();
          const windowHalfHeight = window.innerHeight / 2;

          if (rect.top < windowHalfHeight && rect.top >= 0) {
            if(button.hasAttribute('aria-current')) return;
              this.toggleActiveButton(button);
          }
        });

        this.isAnimating = this.isScrolling;
        
        if (this.isAnimating) {
          requestAnimationFrame(this.trackScrollButtons.bind(this));
        }
      }

      stopScrollTracking() {
        this.isAnimating = false;
      }

      designMode() {
        document.addEventListener('shopify:section:select', (event) => this.toggleStickyReveal(event.target.contains(this)));
      }

      get trackingButtons() {
        return this.scrollButtons.filter(item => !item.hasAttribute('data-scroll-button-target-product'));
      }

      get scrollButtons() {
        return [...this.querySelectorAll('[data-scroll-target]')];
      }

      get stickyReveal() {
        return this.dataset.stickyReveal === 'true';
      }

      get stickyRevealTarget() {
        return document.getElementById(this.dataset.stickyRevealTarget);
      }
    }
  );
}